import { render } from "./BuyerOrderDetails.vue?vue&type=template&id=131ab880&scoped=true"
import script from "./BuyerOrderDetails.vue?vue&type=script&lang=js"
export * from "./BuyerOrderDetails.vue?vue&type=script&lang=js"

import "./BuyerOrderDetails.vue?vue&type=style&index=0&id=131ab880&lang=less&scoped=true"

import exportComponent from "/data/web/antpay-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131ab880"]])

export default __exports__